import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { get_make_model_data, get_zywave_make, get_zywave_model, get_zywave_vin } from "../api/api-requests";
import Button from "../components/button";
import Checkbox from "../components/checkbox";
import Dropdown from "../components/dropdown";
import Error from "../components/error";
import Footer from "../components/footer";
import Icon from "../components/icon";
import Label from "../components/label";
import { Link, Title, RowContainer } from "../components/description";

const VehWrapper = styled.div`
	.trust-signal {
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
		align-items: center;
		margin-top: 7rem;

		@media (max-width: 475px) {
			flex-direction: column;
		}
	}

	.browse-privately {
		display: flex;
		max-width: 200px;
		margin-right: 10px;

		@media (max-width: 475px) {
			margin-bottom: 4rem;
			margin-right: 0;
		}
	}
`;

function Vehicles({ type, goToNextStep, setFieldValue, ...props }) {
	const yearList = [
		{ label: 2026, value: 2026 },
		{ label: 2025, value: 2025 },
		{ label: 2024, value: 2024 },
		{ label: 2023, value: 2023 },
		{ label: 2022, value: 2022 },
		{ label: 2021, value: 2021 },
		{ label: 2020, value: 2020 },
		{ label: 2019, value: 2019 },
		{ label: 2018, value: 2018 },
		{ label: 2017, value: 2017 },
		{ label: 2016, value: 2016 },
		{ label: 2015, value: 2015 },
		{ label: 2014, value: 2014 },
		{ label: 2013, value: 2013 },
		{ label: 2012, value: 2012 },
		{ label: 2011, value: 2011 },
		{ label: 2010, value: 2010 },
		{ label: 2009, value: 2009 },
		{ label: 2008, value: 2008 },
		{ label: 2007, value: 2007 },
		{ label: 2006, value: 2006 },
		{ label: 2005, value: 2005 },
		{ label: 2004, value: 2004 },
	];
	const [isSectionVisited, setIsSectionVisited] = useState(false);
	const [showContinue, setShowContinue] = useState(false);
	const [show3rdContinue, setShow3rdContinue] = useState(false);

	const [showVehicleSelect, setShowVehicleSelect] = useState(true);
	const [showVehicleUsage, setShowVehicleUsage] = useState(false);
	const [showVehicleMiles, setShowVehicleMiles] = useState(false);
	const [showVehicleAnother, setShowVehicleAnother] = useState(false);
	const [makeModelData, setMakeModelData] = useState({});
	const [makeList, setMakeList] = useState([]);
	const [modelList, setModelList] = useState([]);

	const [showVehicleSelect1, setShowVehicleSelect1] = useState(true);
	const [showVehicleUsage1, setShowVehicleUsage1] = useState(false);
	const [showVehicleMiles1, setShowVehicleMiles1] = useState(false);
	const [showVehicleAnother1, setShowVehicleAnother1] = useState(false);
	const [makeModelData1, setMakeModelData1] = useState({});
	const [makeList1, setMakeList1] = useState([]);
	const [modelList1, setModelList1] = useState([]);

	const [showVehicleSelect2, setShowVehicleSelect2] = useState(true);
	const [showVehicleUsage2, setShowVehicleUsage2] = useState(false);
	const [showVehicleMiles2, setShowVehicleMiles2] = useState(false);
	const [makeModelData2, setMakeModelData2] = useState({});
	const [makeList2, setMakeList2] = useState([]);
	const [modelList2, setModelList2] = useState([]);

	useEffect(() => {
		setMakeList(sessionStorage.getItem("vehicle1MakeList") ? JSON.parse(sessionStorage.getItem("vehicle1MakeList")) : []);
		setModelList(sessionStorage.getItem("vehicle1ModelList") ? JSON.parse(sessionStorage.getItem("vehicle1ModelList")) : []);
		setMakeList1(sessionStorage.getItem("vehicle2MakeList") ? JSON.parse(sessionStorage.getItem("vehicle2MakeList")) : []);
		setModelList1(sessionStorage.getItem("vehicle2ModelList") ? JSON.parse(sessionStorage.getItem("vehicle2ModelList")) : []);
		setMakeList2(sessionStorage.getItem("vehicle3MakeList") ? JSON.parse(sessionStorage.getItem("vehicle3MakeList")) : []);
		setModelList2(sessionStorage.getItem("vehicle3ModelList") ? JSON.parse(sessionStorage.getItem("vehicle3ModelList")) : []);
		const sectionFinished = sessionStorage.getItem("rrQuizVehicleSectionVisited");
		if (sectionFinished && sectionFinished == "true") {
			setIsSectionVisited(true);
		} else {
			switch (props.values.vehicles.length) {
				case 1:
					if (!props.values.vehicles[0].year || !props.values.vehicles[0].make || !props.values.vehicles[0].model) {
						setShowVehicleSelect(true);
					} else if (!props.values.vehicles[0].usage) {
						if (!props.isVehicleInfoAutoSelected) {
							setShowVehicleSelect(false);
							setShowVehicleUsage(true);
						} else {
							setShowVehicleSelect(true);
						}
					} else {
						setShowVehicleSelect(false);
						setShowVehicleUsage(false);
						setShowVehicleMiles(true);
					}
					break;
				case 2:
					setShowVehicleSelect(false);
					setShowVehicleUsage(false);
					setShowVehicleMiles(false);
					if (!props.values.vehicles[1].year || !props.values.vehicles[1].make || !props.values.vehicles[1].model) {
						setShowVehicleSelect1(true);
					} else if (!props.values.vehicles[1].usage) {
						setShowVehicleSelect1(false);
						setShowVehicleUsage1(true);
					} else {
						setShowVehicleSelect1(false);
						setShowVehicleUsage1(false);
						setShowVehicleMiles1(true);
					}
					break;
				case 3:
					setShowVehicleSelect(false);
					setShowVehicleUsage(false);
					setShowVehicleMiles(false);
					setShowVehicleSelect1(false);
					setShowVehicleUsage1(false);
					setShowVehicleMiles1(false);
					if (!props.values.vehicles[2].year || !props.values.vehicles[2].make || !props.values.vehicles[2].model) {
						setShowVehicleSelect2(true);
					} else if (!props.values.vehicles[2].usage) {
						setShowVehicleSelect2(false);
						setShowVehicleUsage2(true);
					} else {
						setShowVehicleSelect2(false);
						setShowVehicleUsage2(false);
						setShowVehicleMiles2(true);
					}
					break;
			}
		}
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	useEffect(() => {
		if (props.queryVehicle) {
			if (props.queryVehicle.year && props.queryVehicle.make && props.queryVehicle.model) {
				onVehicleYearChange(props.queryVehicle.year, 0);
				// onVehicleMakeChange(props.queryVehicle.make, 0);
				// onVehicleModelChange(props.queryVehicle.model, 0);
			}
		}
	}, [props.queryVehicle]);

	async function onVehicleYearChange(value, index) {
		if (index == 0) {
			setMakeList([]);
			sessionStorage.setItem("vehicle1MakeList", JSON.stringify([]));
		} else if (index == 1) {
			setMakeList1([]);
			sessionStorage.setItem("vehicle2MakeList", JSON.stringify([]));
		} else {
			setMakeList2([]);
			sessionStorage.setItem("vehicle3MakeList", JSON.stringify([]));
		}
		const newItems = [...props.values.vehicles];
		let vehicle = newItems[index];
		vehicle.year = value;
		vehicle.make = "";
		vehicle.model = "";
		newItems[index] = vehicle;
		setFieldValue("vehicles", newItems);

		try {
			const { data } = await get_make_model_data(value);
			let tempMakeList = [];
			const makeModelForYear = data.reduce((acc, row) => {
				if (!acc[row.make]) {
					acc[row.make] = [];
					tempMakeList.push({ label: row.make, value: row.make });
				}
				acc[row.make].push({ label: row.model, value: row.model });
				return acc;
			}, {});

			if (index == 0) {
				setMakeModelData(makeModelForYear);
				setMakeList(tempMakeList);
				sessionStorage.setItem("vehicle1MakeList", JSON.stringify(tempMakeList));
			} else if (index == 1) {
				setMakeModelData1(makeModelForYear);
				setMakeList1(tempMakeList);
				sessionStorage.setItem("vehicle2MakeList", JSON.stringify(tempMakeList));
			} else {
				setMakeModelData2(makeModelForYear);
				setMakeList2(tempMakeList);
				sessionStorage.setItem("vehicle3MakeList", JSON.stringify(tempMakeList));
			}
		} catch (err) {
			console.log(err);
		}
	}
	async function onVehicleMakeChange(value, index) {
		if (index == 0) {
			setModelList([]);
			sessionStorage.setItem("vehicle1ModelList", JSON.stringify([]));
		} else if (index == 1) {
			setModelList1([]);
			sessionStorage.setItem("vehicle2ModelList", JSON.stringify([]));
		} else {
			setModelList2([]);
			sessionStorage.setItem("vehicle3ModelList", JSON.stringify([]));
		}
		const newItems = [...props.values.vehicles];
		let vehicle = newItems[index];
		vehicle.make = value;
		vehicle.model = "";
		newItems[index] = vehicle;
		setFieldValue("vehicles", newItems);

		try {
			const { data } = await get_make_model_data(newItems[index].year);
			let tempMakeList = [];
			const makeModelForYear = data.reduce((acc, row) => {
				if (!acc[row.make]) {
					acc[row.make] = [];
					tempMakeList.push({ label: row.make, value: row.make });
				}
				acc[row.make].push({ label: row.model, value: row.model });
				return acc;
			}, {});

			if (index == 0) {
				if (makeModelData[value]) {
					setModelList(makeModelData[value]);
					sessionStorage.setItem("vehicle1ModelList", JSON.stringify(makeModelData[value]));
				} else {
					setMakeModelData(makeModelForYear);
					setModelList(makeModelForYear[value]);
					sessionStorage.setItem("vehicle1ModelList", JSON.stringify(makeModelForYear[value]));
				}
			} else if (index == 1) {
				if (makeModelData1[value]) {
					setModelList1(makeModelData1[value]);
					sessionStorage.setItem("vehicle2ModelList", JSON.stringify(makeModelData1[value]));
				} else {
					setMakeModelData1(makeModelForYear);
					setModelList1(makeModelForYear[value]);
					sessionStorage.setItem("vehicle2ModelList", JSON.stringify(makeModelForYear[value]));
				}
			} else {
				if (makeModelData2[value]) {
					setModelList2(makeModelData2[value]);
					sessionStorage.setItem("vehicle3ModelList", JSON.stringify(makeModelData2[value]));
				} else {
					setMakeModelData2(makeModelForYear);
					setModelList2(makeModelForYear[value]);
					sessionStorage.setItem("vehicle3ModelList", JSON.stringify(makeModelForYear[value]));
				}
			}
		} catch (err) {
			console.log(err);
		}
	}
	function onVehicleModelChange(value, index) {
		const newItems = [...props.values.vehicles];
		let vehicle = newItems[index];
		vehicle.model = value;
		newItems[index] = vehicle;
		setFieldValue("vehicles", newItems);
		if (index == 0) {
			if (!props.isVehicleInfoAutoSelected) {
				if ((type == "AUTO" || type == "BUNDLE") && !isSectionVisited) {
					window.location.reload();
				}
				setShowVehicleSelect(false);
				setShowVehicleUsage(true);
			}
		} else if (index == 1) {
			setShowVehicleSelect1(false);
			setShowVehicleUsage1(true);
		} else {
			setShowVehicleSelect2(false);
			setShowVehicleUsage2(true);
		}
	}
	function onVehicleBackClick(index) {
		if (index == 1) {
			setShowVehicleSelect1(false);
			setShowVehicleAnother(true);
		} else if (index == 2) {
			setShowVehicleSelect2(false);
			setShowVehicleAnother1(true);
		}
	}
	function onVehicleNextClick(index) {
		props.setTouched({
			vehicles: props.values.vehicles.map(() => ({
				year: true,
				make: true,
				model: true,
			})),
		});
		props.validateForm().then((errors) => {
			if (index == 0 && props.values.vehicles && props.values.vehicles[0] && props.values.vehicles[0].year != "" && props.values.vehicles[0].make != "" && props.values.vehicles[0].model != "") {
				setShowVehicleSelect(false);
				setShowVehicleUsage(true);
				props.setIsVehicleInfoAutoSelected(false);
				window.location.reload();
			} else if (
				index == 1 &&
				props.values.vehicles &&
				props.values.vehicles[1] &&
				props.values.vehicles[1].year != "" &&
				props.values.vehicles[1].make != "" &&
				props.values.vehicles[1].model != ""
			) {
				setShowVehicleSelect1(false);
				setShowVehicleUsage1(true);
			} else if (
				index == 2 &&
				props.values.vehicles &&
				props.values.vehicles[2] &&
				props.values.vehicles[2].year != "" &&
				props.values.vehicles[2].make != "" &&
				props.values.vehicles[2].model != ""
			) {
				setShowVehicleSelect2(false);
				setShowVehicleUsage2(true);
			} else {
				console.log(errors);
			}
		});
	}

	function onVehicleUsageBack(index) {
		if (index == 0) {
			setShowVehicleUsage(false);
			setShowVehicleSelect(true);
		} else if (index == 1) {
			setShowVehicleUsage1(false);
			setShowVehicleSelect1(true);
		} else {
			setShowVehicleUsage2(false);
			setShowVehicleSelect2(true);
		}
	}
	function onVehicleUsageNext(index) {
		props.setTouched({
			vehicles: props.values.vehicles.map(() => ({
				usage: true,
			})),
		});
		props.validateForm().then((errors) => {
			if (index == 0 && props.values.vehicles && props.values.vehicles[0] && props.values.vehicles[0].usage != "") {
				setShowVehicleUsage(false);
				setShowVehicleMiles(true);
			} else if (index == 1 && props.values.vehicles && props.values.vehicles[1] && props.values.vehicles[1].usage != "") {
				setShowVehicleUsage1(false);
				setShowVehicleMiles1(true);
			} else if (index == 2 && props.values.vehicles && props.values.vehicles[2] && props.values.vehicles[2].usage != "") {
				setShowVehicleUsage2(false);
				setShowVehicleMiles2(true);
			} else {
				console.log(errors);
			}
		});
		document.getElementById("rr-quiz-flow-heading-mobile") ? (document.getElementById("rr-quiz-flow-heading-mobile").style.display = "none") : undefined;
		document.getElementById("rr-quiz-flow-subheading-mobile") ? (document.getElementById("rr-quiz-flow-subheading-mobile").style.display = "none") : undefined;
		document.getElementById("rr-quiz-flow-heading-desktop") ? (document.getElementById("rr-quiz-flow-heading-desktop").style.display = "none") : undefined;
		document.getElementById("rr-quiz-flow-subheading-desktop") ? (document.getElementById("rr-quiz-flow-subheading-desktop").style.display = "none") : undefined;
	}
	function onVehicleUsageChange(value, index) {
		const newItems = [...props.values.vehicles];
		let vehicle = newItems[index];
		vehicle.usage = value;
		newItems[index] = vehicle;
		setFieldValue("vehicles", newItems);
		setTimeout(() => {
			if (index == 0) {
				setShowVehicleUsage(false);
				setShowVehicleMiles(true);
			} else if (index == 1) {
				setShowVehicleUsage1(false);
				setShowVehicleMiles1(true);
			} else {
				setShowVehicleUsage2(false);
				setShowVehicleMiles2(true);
			}
			document.getElementById("rr-quiz-flow-heading-mobile") ? (document.getElementById("rr-quiz-flow-heading-mobile").style.display = "none") : undefined;
			document.getElementById("rr-quiz-flow-subheading-mobile") ? (document.getElementById("rr-quiz-flow-subheading-mobile").style.display = "none") : undefined;
			document.getElementById("rr-quiz-flow-heading-desktop") ? (document.getElementById("rr-quiz-flow-heading-desktop").style.display = "none") : undefined;
			document.getElementById("rr-quiz-flow-subheading-desktop") ? (document.getElementById("rr-quiz-flow-subheading-desktop").style.display = "none") : undefined;
		}, 200);
	}

	function onVehicleMilesBack(index) {
		if (index == 0) {
			setShowVehicleMiles(false);
			setShowVehicleUsage(true);
		} else if (index == 1) {
			setShowVehicleMiles1(false);
			setShowVehicleUsage1(true);
		} else {
			setShowVehicleMiles2(false);
			setShowVehicleUsage2(true);
		}
	}
	function onVehicleMilesNext(index) {
		props.setTouched({
			vehicles: props.values.vehicles.map(() => ({
				dailyMileage: true,
			})),
		});
		props.validateForm().then((errors) => {
			if (index == 0 && props.values.vehicles && props.values.vehicles[0] && props.values.vehicles[0].dailyMileage != "") {
				setShowVehicleMiles(false);
				setShowVehicleAnother(true);
			} else if (index == 1 && props.values.vehicles && props.values.vehicles[1] && props.values.vehicles[1].dailyMileage != "") {
				setShowVehicleMiles1(false);
				setShowVehicleAnother1(true);
			} else if (index == 2 && props.values.vehicles && props.values.vehicles[2] && props.values.vehicles[2].dailyMileage != "") {
				setShow3rdContinue(true);
			} else {
				console.log(errors);
			}
		});
	}
	function onVehicleMilesChange(value, index) {
		const newItems = [...props.values.vehicles];
		let vehicle = newItems[index];
		vehicle.dailyMileage = value;
		newItems[index] = vehicle;
		setFieldValue("vehicles", newItems);
		setTimeout(() => {
			if (index == 0) {
				setShowVehicleMiles(false);
				setShowVehicleAnother(true);
			} else if (index == 1) {
				setShowVehicleMiles1(false);
				setShowVehicleAnother1(true);
			} else {
				setShow3rdContinue(true);
			}
		}, 200);
	}

	function onVehicleAnotherBack(index) {
		if (index == 0) {
			setShowVehicleAnother(false);
			setShowVehicleMiles(true);
		} else if (index == 1) {
			setShowVehicleAnother1(false);
			setShowVehicleMiles1(true);
		}
	}
	function onVehicleAnotherNext(index) {
		props.setTouched({
			vehicles: props.values.vehicles.map(() => ({
				anotherText: true,
			})),
		});
		props.validateForm().then((errors) => {
			if (props.values.vehicles[index].anotherText != "") {
				if (props.values.vehicles[index].anotherText == "Yes") {
					if (index == 0) {
						setShowVehicleSelect(false);
						setShowVehicleUsage(false);
						setShowVehicleMiles(false);
						setShowVehicleAnother(false);
						setShowVehicleSelect1(true);
					} else if (index == 1) {
						setShowVehicleSelect(false);
						setShowVehicleUsage(false);
						setShowVehicleMiles(false);
						setShowVehicleAnother(false);
						setShowVehicleSelect1(false);
						setShowVehicleUsage1(false);
						setShowVehicleMiles1(false);
						setShowVehicleAnother1(false);
						setShowVehicleSelect2(true);
					}
					setShowContinue(false);
				} else if (props.values.vehicles[index].anotherText == "No") {
					vehicleContinueClick();
				}
			} else {
				console.log(errors);
			}
		});
	}
	function onVehicleAddMore(index, value) {
		const newVehs = [...props.values.vehicles];
		let vehicle = newVehs[index];
		vehicle.anotherText = value;
		newVehs[index] = vehicle;

		if (value == "No") {
			setShowContinue(true);
			newVehs.splice(index + 1);
			setFieldValue("vehicles", newVehs);
		} else {
			if ((index == 0 && !newVehs[1]) || (index == 1 && !newVehs[2])) {
				let newVehicle = {
					year: "",
					make: "",
					model: "",
					usage: "",
					dailyMileage: "",
					anotherText: newVehs.length == 2 ? "No" : "",
				};
				newVehs.push(newVehicle);
			}
			setFieldValue("vehicles", newVehs);

			if (isSectionVisited) {
				setIsSectionVisited(false);
			}
			if (index == 0) {
				setShowVehicleSelect(false);
				setShowVehicleUsage(false);
				setShowVehicleMiles(false);
				setShowVehicleAnother(false);
				setShowVehicleSelect1(true);
			} else if (index == 1) {
				setShowVehicleSelect(false);
				setShowVehicleUsage(false);
				setShowVehicleMiles(false);
				setShowVehicleAnother(false);
				setShowVehicleSelect1(false);
				setShowVehicleUsage1(false);
				setShowVehicleMiles1(false);
				setShowVehicleAnother1(false);
				setShowVehicleSelect2(true);
			}
			setShowContinue(false);
		}
	}
	function removeVehicle(index) {
		let newVehs = [...props.values.vehicles];
		newVehs[index - 1].anotherText = "No";
		newVehs.splice(index, 1);
		setFieldValue("vehicles", newVehs);
	}

	function vehicleContinueClick() {
		props.setTouched({
			vehicles: props.values.vehicles.map(() => ({
				year: true,
				make: true,
				model: true,
				usage: true,
				dailyMileage: true,
			})),
		});
		props.validateForm().then((errors) => {
			if (Object.keys(errors).length === 0) {
				props.setIsVehicleSectionCompleted(true);
				const newItems = [...props.steps];
				// Current step
				let currentStepIndex = newItems.findIndex((row) => row.key === "VEHICLE");
				let step = newItems[currentStepIndex];
				step.isVisited = "true";
				step.isDisabled = "false";
				newItems[currentStepIndex] = step;
				// Next step
				step = newItems[currentStepIndex + 1];
				step.isDisabled = "false";
				newItems[currentStepIndex + 1] = step;
				props.setSteps(newItems);

				if (props.values.bundleInsurance == "true") {
					if (type != "HOME") {
						props.setProgressPercentage(25);
					} else {
						props.setProgressPercentage(60);
					}
				} else {
					props.setProgressPercentage(33);
				}
				sessionStorage.setItem("rrQuizVehicleSectionVisited", "true");
				goToNextStep("DRIVER", true);
			} else {
				console.log(errors);
			}
		});
	}

	return (
		<VehWrapper>
			{props.values.vehicles &&
				props.values.vehicles.map((vehicle, index) => {
					return (
						<React.Fragment key={index}>
							{index == 0 && (
								<>
									{isSectionVisited && <Title>Vehicle 1</Title>}

									{(isSectionVisited || showVehicleSelect) && (
										<React.Fragment>
											<Label text={`${type != "HOME" ? "First things first, w" : "W"}hat car do you drive?`}></Label>
											<Dropdown
												placeholder="Select vehicle year"
												name={`vehicles[${index}].year`}
												value={`vehicles[${index}].year`}
												onChange={(value) => {
													onVehicleYearChange(value, index);
												}}
												options={yearList}
												error={`${
													props.touched &&
													props.touched.vehicles &&
													props.touched.vehicles[index] &&
													props.touched.vehicles[index].year &&
													props.errors &&
													props.errors.vehicles &&
													props.errors.vehicles[index] &&
													props.errors.vehicles[index].year
												}`}
												marginBottom="1rem"
											/>

											{(isSectionVisited || (vehicle.year && makeList && makeList.length > 0)) && (
												<Dropdown
													placeholder="Select vehicle make"
													value={`vehicles[${index}].make`}
													name={`vehicles[${index}].make`}
													onChange={(value) => {
														onVehicleMakeChange(value, index);
													}}
													options={makeList}
													error={`${
														props.touched &&
														props.touched.vehicles &&
														props.touched.vehicles[index] &&
														props.touched.vehicles[index].make &&
														props.errors &&
														props.errors.vehicles &&
														props.errors.vehicles[index] &&
														props.errors.vehicles[index].make
													}`}
													noOptionsMessage="Please re-select year"
													marginBottom="1rem"
												/>
											)}

											{(isSectionVisited || (vehicle.year && vehicle.make && modelList && modelList.length > 0)) && (
												<>
													<Dropdown
														placeholder="Select vehicle model"
														value={`vehicles[${index}].model`}
														name={`vehicles[${index}].model`}
														onChange={(value) => {
															onVehicleModelChange(value, index);
														}}
														options={modelList}
														error={`${
															props.touched &&
															props.touched.vehicles &&
															props.touched.vehicles[index] &&
															props.touched.vehicles[index].model &&
															props.errors &&
															props.errors.vehicles &&
															props.errors.vehicles[index] &&
															props.errors.vehicles[index].model
														}`}
														noOptionsMessage="Please re-select make"
														marginBottom="1rem"
													/>
													{!isSectionVisited && <Footer showBack={false} forwardClick={() => onVehicleNextClick(index)} />}
												</>
											)}

											{!isSectionVisited && type != "HOME" && (
												<div className="trust-signal">
													<div className="browse-privately">
														<Icon viewBox="0 0 30 38" icon="lock" size={24} stroke="#004ECC" color="#004ECC" />
														<div style={{ display: "flex", flexDirection: "column" }}>
															<span style={{ fontSize: "16px", fontWeight: "800" }}>Browse Privately</span>
															<span style={{ fontSize: "15px", lineHeight: "20px" }}>We won't ask for your phone or email now</span>
														</div>
													</div>
													<img style={{ height: "50px" }} src="/wp-content/uploads/2026/06/blue-seal-200-42-bbb-235981197.png" />
												</div>
											)}
										</React.Fragment>
									)}

									{/* /wp-content/uploads/2026/06/blue-seal-200-42-bbb-235981197.png */}
									{/* /wp-content/uploads/2023/11/Lock.svg */}

									{(isSectionVisited || showVehicleUsage) && (
										<React.Fragment>
											<Label text={`What do you use your ${vehicle.make} for?`}></Label>
											<Checkbox
												label="Daily travel/commute (most common)"
												checked={vehicle.usage === "Work"}
												onClick={() => {
													onVehicleUsageChange("Work", index);
												}}
											/>
											<Checkbox
												label="Leisure/personal trips"
												checked={vehicle.usage === "Pleasure"}
												onClick={() => {
													onVehicleUsageChange("Pleasure", index);
												}}
											/>
											<Checkbox
												label="Rideshare/business"
												checked={vehicle.usage === "Business"}
												onClick={() => {
													onVehicleUsageChange("Business", index);
												}}
											/>
											<Checkbox
												label="Farming"
												checked={vehicle.usage === "Farm"}
												onClick={() => {
													onVehicleUsageChange("Farm", index);
												}}
											/>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].usage &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].usage && <Error text={props.errors.vehicles[index].usage} />}

											{!isSectionVisited && <Footer backClick={() => onVehicleUsageBack(index)} forwardClick={() => onVehicleUsageNext(index)} />}
										</React.Fragment>
									)}

									{(isSectionVisited || showVehicleMiles) && (
										<React.Fragment>
											<Label text="How many miles a day do you drive?"></Label>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="5"
													checked={vehicle.dailyMileage === 5}
													onClick={() => {
														onVehicleMilesChange(5, index);
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="10"
													checked={vehicle.dailyMileage === 10}
													onClick={() => {
														onVehicleMilesChange(10, index);
													}}
													style={{ width: "100%" }}
												/>
											</div>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="20"
													checked={vehicle.dailyMileage === 20}
													onClick={() => {
														onVehicleMilesChange(20, index);
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="30+"
													checked={vehicle.dailyMileage === 30}
													onClick={() => {
														onVehicleMilesChange(30, index);
													}}
													style={{ width: "100%" }}
												/>
											</div>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].dailyMileage &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].dailyMileage && <Error text={props.errors.vehicles[index].dailyMileage} />}

											{!isSectionVisited && <Footer backClick={() => onVehicleMilesBack(index)} forwardClick={() => onVehicleMilesNext(index)} />}
										</React.Fragment>
									)}

									{(showVehicleAnother || (isSectionVisited && props.values.vehicles.length == 1)) && (
										<React.Fragment>
											<Label text="Do you want to add another vehicle?"></Label>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="Yes"
													checked={vehicle.anotherText === "Yes"}
													onClick={() => {
														onVehicleAddMore(index, "Yes");
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="No"
													checked={vehicle.anotherText === "No"}
													onClick={() => {
														onVehicleAddMore(index, "No");
													}}
													style={{ width: "100%" }}
												/>
											</div>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].anotherText &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].anotherText && <Error text={props.errors.vehicles[index].anotherText} />}
											{!isSectionVisited && !showContinue && <Footer backClick={() => onVehicleAnotherBack(index)} forwardClick={() => onVehicleAnotherNext(index)} />}
										</React.Fragment>
									)}
								</>
							)}

							{index == 1 && (
								<>
									{isSectionVisited && (
										<RowContainer style={{ justifyContent: "space-between" }}>
											<Title>Vehicle 2</Title>
											<Link>
												<div className="light-link" onClick={() => removeVehicle(index)}>
													{vehicle.make ? `Remove ${vehicle.make}` : "Remove this Vehicle"}
												</div>
											</Link>
										</RowContainer>
									)}

									{(isSectionVisited || (!showVehicleSelect && showVehicleSelect1)) && (
										<React.Fragment>
											<Label text="Second vehicle: What car do you drive?"></Label>
											<Dropdown
												placeholder="Select vehicle year"
												name={`vehicles[${index}].year`}
												value={`vehicles[${index}].year`}
												onChange={(value) => {
													onVehicleYearChange(value, index);
												}}
												options={yearList}
												error={`${
													props.touched &&
													props.touched.vehicles &&
													props.touched.vehicles[index] &&
													props.touched.vehicles[index].year &&
													props.errors &&
													props.errors.vehicles &&
													props.errors.vehicles[index] &&
													props.errors.vehicles[index].year
												}`}
												marginBottom="1rem"
											/>

											{(isSectionVisited || (vehicle.year && makeList1 && makeList1.length > 0)) && (
												<Dropdown
													placeholder="Select vehicle make"
													name={`vehicles[${index}].make`}
													value={`vehicles[${index}].make`}
													onChange={(value) => {
														onVehicleMakeChange(value, index);
													}}
													options={makeList1}
													error={`${
														props.touched &&
														props.touched.vehicles &&
														props.touched.vehicles[index] &&
														props.touched.vehicles[index].make &&
														props.errors &&
														props.errors.vehicles &&
														props.errors.vehicles[index] &&
														props.errors.vehicles[index].make
													}`}
													noOptionsMessage="Please re-select year"
													marginBottom="1rem"
												/>
											)}

											{(isSectionVisited || (vehicle.year && vehicle.make && modelList1 && modelList1.length > 0)) && (
												<>
													<Dropdown
														placeholder="Select vehicle model"
														name={`vehicles[${index}].model`}
														value={`vehicles[${index}].model`}
														onChange={(value) => {
															onVehicleModelChange(value, index);
														}}
														options={modelList1}
														error={`${
															props.touched &&
															props.touched.vehicles &&
															props.touched.vehicles[index] &&
															props.touched.vehicles[index].model &&
															props.errors &&
															props.errors.vehicles &&
															props.errors.vehicles[index] &&
															props.errors.vehicles[index].model
														}`}
														noOptionsMessage="Please re-select make"
														marginBottom="1rem"
													/>
												</>
											)}

											{!isSectionVisited && <Footer backClick={() => onVehicleBackClick(index)} forwardClick={() => onVehicleNextClick(index)} />}
										</React.Fragment>
									)}

									{(isSectionVisited || showVehicleUsage1) && (
										<React.Fragment>
											<Label text={`Second vehicle: What do you use your ${vehicle.make} for?`}></Label>
											<Checkbox
												label="Daily travel/commute (most common)"
												checked={vehicle.usage === "Work"}
												onClick={() => {
													onVehicleUsageChange("Work", index);
												}}
											/>
											<Checkbox
												label="Leisure/personal trips"
												checked={vehicle.usage === "Pleasure"}
												onClick={() => {
													onVehicleUsageChange("Pleasure", index);
												}}
											/>
											<Checkbox
												label="Rideshare/business"
												checked={vehicle.usage === "Business"}
												onClick={() => {
													onVehicleUsageChange("Business", index);
												}}
											/>
											<Checkbox
												label="Farming"
												checked={vehicle.usage === "Farm"}
												onClick={() => {
													onVehicleUsageChange("Farm", index);
												}}
											/>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].usage &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].usage && <Error text={props.errors.vehicles[index].usage} />}

											{!isSectionVisited && <Footer backClick={() => onVehicleUsageBack(index)} forwardClick={() => onVehicleUsageNext(index)} />}
										</React.Fragment>
									)}

									{(isSectionVisited || showVehicleMiles1) && (
										<React.Fragment>
											<Label text="Second vehicle: How many miles a day do you drive?"></Label>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="5"
													checked={vehicle.dailyMileage === 5}
													onClick={() => {
														onVehicleMilesChange(5, index);
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="10"
													checked={vehicle.dailyMileage === 10}
													onClick={() => {
														onVehicleMilesChange(10, index);
													}}
													style={{ width: "100%" }}
												/>
											</div>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="20"
													checked={vehicle.dailyMileage === 20}
													onClick={() => {
														onVehicleMilesChange(20, index);
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="30+"
													checked={vehicle.dailyMileage === 30}
													onClick={() => {
														onVehicleMilesChange(30, index);
													}}
													style={{ width: "100%" }}
												/>
											</div>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].dailyMileage &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].dailyMileage && <Error text={props.errors.vehicles[index].dailyMileage} />}

											{!isSectionVisited && <Footer backClick={() => onVehicleMilesBack(index)} forwardClick={() => onVehicleMilesNext(index)} />}
										</React.Fragment>
									)}

									{(showVehicleAnother1 || (isSectionVisited && props.values.vehicles.length == 2)) && (
										<React.Fragment>
											<Label text="Do you want to add another vehicle?"></Label>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="Yes"
													checked={vehicle.anotherText === "Yes"}
													onClick={() => {
														onVehicleAddMore(index, "Yes");
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="No"
													checked={vehicle.anotherText === "No"}
													onClick={() => {
														onVehicleAddMore(index, "No");
													}}
													style={{ width: "100%" }}
												/>
											</div>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].anotherText &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].anotherText && <Error text={props.errors.vehicles[index].anotherText} />}
											{!isSectionVisited && !showContinue && <Footer backClick={() => onVehicleAnotherBack(index)} forwardClick={() => onVehicleAnotherNext(index)} />}
										</React.Fragment>
									)}
								</>
							)}

							{index == 2 && (
								<>
									{isSectionVisited && (
										<RowContainer style={{ justifyContent: "space-between" }}>
											<Title>Vehicle 3</Title>
											<Link>
												<div className="light-link" onClick={() => removeVehicle(index)}>
													{vehicle.make ? `Remove ${vehicle.make}` : "Remove this Vehicle"}
												</div>
											</Link>
										</RowContainer>
									)}

									{(isSectionVisited || (!showVehicleSelect && !showVehicleSelect1 && showVehicleSelect2)) && (
										<React.Fragment>
											<Label text="Third vehicle: What car do you drive?"></Label>
											<Dropdown
												placeholder="Select vehicle year"
												name={`vehicles[${index}].year`}
												value={`vehicles[${index}].year`}
												onChange={(value) => {
													onVehicleYearChange(value, index);
												}}
												options={yearList}
												error={`${
													props.touched &&
													props.touched.vehicles &&
													props.touched.vehicles[index] &&
													props.touched.vehicles[index].year &&
													props.errors &&
													props.errors.vehicles &&
													props.errors.vehicles[index] &&
													props.errors.vehicles[index].year
												}`}
												marginBottom="1rem"
											/>

											{(isSectionVisited || (vehicle.year && makeList2 && makeList2.length > 0)) && (
												<Dropdown
													placeholder="Select vehicle make"
													name={`vehicles[${index}].make`}
													value={`vehicles[${index}].make`}
													onChange={(value) => {
														onVehicleMakeChange(value, index);
													}}
													options={makeList2}
													error={`${
														props.touched &&
														props.touched.vehicles &&
														props.touched.vehicles[index] &&
														props.touched.vehicles[index].make &&
														props.errors &&
														props.errors.vehicles &&
														props.errors.vehicles[index] &&
														props.errors.vehicles[index].make
													}`}
													noOptionsMessage="Please re-select year"
													marginBottom="1rem"
												/>
											)}

											{(isSectionVisited || (vehicle.year && vehicle.make && modelList2 && modelList2.length > 0)) && (
												<>
													<Dropdown
														placeholder="Select vehicle model"
														name={`vehicles[${index}].model`}
														value={`vehicles[${index}].model`}
														onChange={(value) => {
															onVehicleModelChange(value, index);
														}}
														options={modelList2}
														error={`${
															props.touched &&
															props.touched.vehicles &&
															props.touched.vehicles[index] &&
															props.touched.vehicles[index].model &&
															props.errors &&
															props.errors.vehicles &&
															props.errors.vehicles[index] &&
															props.errors.vehicles[index].model
														}`}
														noOptionsMessage="Please re-select make"
														marginBottom="1rem"
													/>
												</>
											)}

											{!isSectionVisited && <Footer backClick={() => onVehicleBackClick(index)} forwardClick={() => onVehicleNextClick(index)} />}
										</React.Fragment>
									)}

									{(isSectionVisited || showVehicleUsage2) && (
										<React.Fragment>
											<Label text={`Third vehicle: What do you use your ${vehicle.make} for?`}></Label>
											<Checkbox
												label="Daily travel/commute (most common)"
												checked={vehicle.usage === "Work"}
												onClick={() => {
													onVehicleUsageChange("Work", index);
												}}
											/>
											<Checkbox
												label="Leisure/personal trips"
												checked={vehicle.usage === "Pleasure"}
												onClick={() => {
													onVehicleUsageChange("Pleasure", index);
												}}
											/>
											<Checkbox
												label="Rideshare/business"
												checked={vehicle.usage === "Business"}
												onClick={() => {
													onVehicleUsageChange("Business", index);
												}}
											/>
											<Checkbox
												label="Farming"
												checked={vehicle.usage === "Farm"}
												onClick={() => {
													onVehicleUsageChange("Farm", index);
												}}
											/>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].usage &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].usage && <Error text={props.errors.vehicles[index].usage} />}

											{!isSectionVisited && <Footer backClick={() => onVehicleUsageBack(index)} forwardClick={() => onVehicleUsageNext(index)} />}
										</React.Fragment>
									)}

									{(isSectionVisited || showVehicleMiles2) && (
										<React.Fragment>
											<Label text="Third vehicle: How many miles a day do you drive?"></Label>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="5"
													checked={vehicle.dailyMileage === 5}
													onClick={() => {
														onVehicleMilesChange(5, index);
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="10"
													checked={vehicle.dailyMileage === 10}
													onClick={() => {
														onVehicleMilesChange(10, index);
													}}
													style={{ width: "100%" }}
												/>
											</div>
											<div style={{ display: "flex", flexDirection: "row" }}>
												<Checkbox
													label="20"
													checked={vehicle.dailyMileage === 20}
													onClick={() => {
														onVehicleMilesChange(20, index);
													}}
													style={{ marginRight: "1rem", width: "100%" }}
												/>
												<Checkbox
													label="30+"
													checked={vehicle.dailyMileage === 30}
													onClick={() => {
														onVehicleMilesChange(30, index);
													}}
													style={{ width: "100%" }}
												/>
											</div>
											{props.touched &&
												props.touched.vehicles &&
												props.touched.vehicles[index] &&
												props.touched.vehicles[index].dailyMileage &&
												props.errors &&
												props.errors.vehicles &&
												props.errors.vehicles[index] &&
												props.errors.vehicles[index].dailyMileage && <Error text={props.errors.vehicles[index].dailyMileage} />}

											{!isSectionVisited && !show3rdContinue && <Footer backClick={() => onVehicleMilesBack(index)} forwardClick={() => onVehicleMilesNext(index)} />}
											{!isSectionVisited && show3rdContinue && (
												<RowContainer style={{ justifyContent: "center", marginTop: "2rem", alignItems: "baseline" }}>
													<Link>
														<div style={{ marginRight: "1rem" }} className="light-link" onClick={() => onVehicleMilesBack(index)}>
															Previous
														</div>
													</Link>
													<Button onClick={vehicleContinueClick} text="Next step" />
												</RowContainer>
											)}
										</React.Fragment>
									)}
								</>
							)}
						</React.Fragment>
					);
				})}

			{(isSectionVisited || showContinue) && <Button onClick={vehicleContinueClick} text="Next step" />}
		</VehWrapper>
	);
}

export default Vehicles;
